import { render } from "./SortTableRouterTypeComponent.vue?vue&type=template&id=5a1f4d66&scoped=true"
import script from "./SortTableRouterTypeComponent.vue?vue&type=script&lang=js"
export * from "./SortTableRouterTypeComponent.vue?vue&type=script&lang=js"

import "./SortTableRouterTypeComponent.vue?vue&type=style&index=0&id=5a1f4d66&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1f4d66"]])

export default __exports__